import { SET_BIKES } from "./bikesTypes";

const initialState = {
  bikes: null
};

const bikesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BIKES:
      return {
        bikes: action.payload
      };
    default:
      return state;
  }
};

export default bikesReducer;
